import { forwardRef } from 'react';
import styled from 'styled-components';
import { Tabs as BaseTabs, TabsProps } from '@mui/material';

type StyledProps = {
  $indicatorBorder?: boolean;
  $allowScroll?: boolean;
};

type Props = TabsProps & {
  indicatorBorder?: boolean;
  allowScroll?: boolean;
};

const StyledTabs = styled(BaseTabs)<StyledProps>`
  width: ${({ orientation }) => (orientation !== 'vertical' ? 'auto' : '100%')};

  &.MuiTabs-root {
    min-height: 0;
  }

  & .MuiTab-root {
    padding: ${({ orientation }) =>
      orientation !== 'vertical' ? '16px' : '8px 16px'};
    margin-left: 0;
    border-left: ${({ theme, $indicatorBorder }) =>
      $indicatorBorder && `2px solid ${theme.palette.common.gray8}`};
    min-height: 0;
    height: ${({ orientation }) => orientation === 'vertical' && '35px'};
    :hover {
      border-radius: ${({ orientation }) =>
        orientation === 'vertical' && '0px 6px 6px 0px'};
    }
  }

  & .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.palette.common.black};
    height: 2px;
    ${({ orientation }) => orientation === 'vertical' && 'left: 0'};
  }

  & .MuiTabs-scroller {
    ${({ $allowScroll }) => $allowScroll && 'overflow-y: auto !important'};
  }
`;

const Tabs = forwardRef<HTMLDivElement, Props>(
  ({ indicatorBorder, allowScroll, ...props }, ref) => (
    <StyledTabs
      ref={ref}
      $indicatorBorder={indicatorBorder}
      $allowScroll={allowScroll}
      {...props}
    />
  ),
);

export default Tabs;
